import React, { ComponentType, useCallback } from "react";

export interface IWithScrollToErrorProps {
  scrollToFirstError: (anchor: string) => void;
}

export const WithScrollToError = <P,>(
  WrappedComponent: ComponentType<P & IWithScrollToErrorProps>
): React.FC<P> => {
  return (props: P) => {
    const scrollToFirstError = useCallback((anchor: string) => {
      const firstError = document.querySelector(`[class*=${anchor}]`);

      if (firstError) {
        firstError.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }, []);

    return (
      <WrappedComponent {...props} scrollToFirstError={scrollToFirstError} />
    );
  };
};
